
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0300"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0300"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
// ── home-main.js ─────────────────────────────────────────────
// Version allégée de main.js pour home.html uniquement.
// Pas de PROJECTS / import.meta.url → évite le bundle partagé
// qui causait l'erreur "Cannot find module 'lgJ39'".
// ──────────────────────────────────────────────────────────────

var $dA2FI = parcelRequire("dA2FI");
// ── i18n init ────────────────────────────────────────────────
(0, $dA2FI.initI18n)();
[
    "lang-switcher-nav",
    "lang-switcher-footer"
].forEach((id)=>{
    const el = document.getElementById(id);
    if (el) el.appendChild((0, $dA2FI.createSwitcher)());
});
// ── Statement words rebuild on lang change ───────────────────
const $871bb6470eebe674$var$STATEMENT_WORDS = {
    fr: [
        "J'aime",
        "cr\xe9er",
        "et",
        "partager,",
        "apprendre",
        "et",
        "d\xe9couvrir,",
        null,
        "raconter",
        "des",
        "histoires",
        "et",
        "les",
        "illustrer."
    ],
    en: [
        "I",
        "love",
        "to",
        "create",
        "and",
        "share,",
        "to",
        "learn",
        "and",
        "discover,",
        null,
        "to",
        "tell",
        "stories",
        "and",
        "bring",
        "them",
        "to",
        "life."
    ]
};
function $871bb6470eebe674$var$rebuildStatement() {
    const p = document.getElementById("statement-text");
    if (!p) return;
    const lang = (0, $dA2FI.getLang)();
    const words = $871bb6470eebe674$var$STATEMENT_WORDS[lang] || $871bb6470eebe674$var$STATEMENT_WORDS.fr;
    p.innerHTML = "";
    words.forEach((w)=>{
        if (w === null) {
            p.appendChild(document.createElement("br"));
            return;
        }
        const span = document.createElement("span");
        span.className = "sw visible"; // keep visible if already seen
        span.textContent = w;
        p.appendChild(span);
        p.appendChild(document.createTextNode(" "));
    });
}
document.addEventListener("langchange", ()=>{
    (0, $dA2FI.applyTranslations)();
    $871bb6470eebe674$var$rebuildStatement();
});
// ── Page transition ───────────────────────────────────────────
const $871bb6470eebe674$var$PageTransition = (()=>{
    const N_BANDS = 4;
    const ENTER_DUR = 500;
    const EXIT_DUR = 550;
    const STAGGER = 60;
    const container = document.getElementById("page-transition");
    let bands = [];
    let rafId = null;
    const easeOutExpo = (t)=>t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
    const easeInExpo = (t)=>t === 0 ? 0 : Math.pow(2, 10 * t - 10);
    function buildBands(startCovered) {
        container.querySelectorAll(".pt-band").forEach((el)=>el.remove());
        bands = [];
        const W = window.innerWidth;
        const bandH = window.innerHeight / N_BANDS;
        for(let i = 0; i < N_BANDS; i++){
            const el = document.createElement("div");
            el.className = "pt-band";
            el.style.top = `${i * bandH}px`;
            el.style.height = `${bandH + 1}px`;
            if (startCovered) el.style.transform = `translateX(${W + 4}px)`;
            container.appendChild(el);
            bands.push(el);
        }
    }
    function enter(onCovered) {
        if (rafId) return;
        buildBands(false);
        container.classList.add("active");
        const W = window.innerWidth;
        const COVERED_AT = ENTER_DUR + (N_BANDS - 1) * STAGGER;
        let called = false;
        const startTs = performance.now();
        function tick(now) {
            const elapsed = now - startTs;
            bands.forEach((el, i)=>{
                const s = i * STAGGER;
                let tx = elapsed < s ? 0 : elapsed < s + ENTER_DUR ? easeOutExpo((elapsed - s) / ENTER_DUR) * (W + 4) : W + 4;
                el.style.transform = `translateX(${tx}px)`;
            });
            if (!called && elapsed >= COVERED_AT) {
                called = true;
                rafId = null;
                if (typeof onCovered === "function") onCovered();
                return;
            }
            rafId = requestAnimationFrame(tick);
        }
        rafId = requestAnimationFrame(tick);
    }
    function exit(onDone) {
        buildBands(true);
        container.classList.add("active");
        document.documentElement.classList.remove("pt-loading");
        const W = window.innerWidth;
        const TOTAL = EXIT_DUR + (N_BANDS - 1) * STAGGER;
        const startTs = performance.now();
        function tick(now) {
            const elapsed = now - startTs;
            bands.forEach((el, i)=>{
                const s = i * STAGGER;
                let tx = elapsed < s ? W + 4 : elapsed < s + EXIT_DUR ? W + 4 + easeInExpo((elapsed - s) / EXIT_DUR) * (W + 4) : (W + 4) * 2;
                el.style.transform = `translateX(${tx}px)`;
            });
            if (elapsed < TOTAL) rafId = requestAnimationFrame(tick);
            else {
                container.classList.remove("active");
                bands.forEach((el)=>el.remove());
                bands = [];
                rafId = null;
                if (typeof onDone === "function") onDone();
            }
        }
        rafId = requestAnimationFrame(tick);
    }
    return {
        enter: enter,
        exit: exit
    };
})();
// Wire up all internal links
document.querySelectorAll("a[href]").forEach((link)=>{
    const href = link.getAttribute("href");
    if (!href || href.startsWith("#") || href.startsWith("http")) return;
    link.addEventListener("click", (e)=>{
        e.preventDefault();
        sessionStorage.setItem("pt-active", "1");
        $871bb6470eebe674$var$PageTransition.enter(()=>{
            window.location.href = href;
        });
    });
});
// ── Letter animation ──────────────────────────────────────────
const $871bb6470eebe674$var$letterFlash = document.getElementById("letter-anim-flash");
function $871bb6470eebe674$var$animateLetters(el, { delay: delay = 80, flashDur: flashDur = 120, squareH: squareH = 0.82, squareV: squareV = 0.08 } = {}) {
    const nodes = Array.from(el.childNodes);
    el.innerHTML = "";
    el.style.display = "flex";
    el.style.flexWrap = "wrap";
    el.style.alignItems = "baseline";
    nodes.forEach((node)=>{
        if (node.nodeType === Node.ELEMENT_NODE && node.tagName === "BR") {
            const br = document.createElement("span");
            br.style.cssText = "width:100%;height:0;display:block;";
            el.appendChild(br);
        } else {
            const text = node.textContent;
            text.split("").forEach((ch)=>{
                const span = document.createElement("span");
                span.className = "letter-anim-char";
                span.textContent = ch === " " ? "\xa0" : ch;
                el.appendChild(span);
            });
        }
    });
    const letters = Array.from(el.querySelectorAll(".letter-anim-char"));
    let flashTimer = null;
    requestAnimationFrame(()=>{
        const widths = letters.map((l)=>l.getBoundingClientRect().width).filter((w)=>w > 4);
        const avgW = widths.length ? Math.round(widths.reduce((a, b)=>a + b, 0) / widths.length) : 40;
        let i = 0;
        function showFlash(letterEl) {
            const rect = letterEl.getBoundingClientRect();
            const h = Math.round(rect.height * squareH);
            const w = avgW;
            const x = rect.left + (rect.width - w) / 2;
            const y = rect.top + rect.height * squareV;
            $871bb6470eebe674$var$letterFlash.style.cssText = `width:${w}px;height:${h}px;left:${x}px;top:${y}px;`;
            $871bb6470eebe674$var$letterFlash.classList.add("on");
            if (flashTimer) clearTimeout(flashTimer);
            flashTimer = setTimeout(()=>$871bb6470eebe674$var$letterFlash.classList.remove("on"), flashDur);
        }
        function step() {
            if (i >= letters.length) return;
            const cur = letters[i];
            cur.classList.add("visible");
            requestAnimationFrame(()=>showFlash(cur));
            i++;
            setTimeout(step, delay);
        }
        setTimeout(step, 200);
    });
}
// Exposé globalement pour home-about.js (classic script)
window.animateLetters = $871bb6470eebe674$var$animateLetters;
// ── Reveal animation ──────────────────────────────────────────
let $871bb6470eebe674$var$revealReady = false;
const $871bb6470eebe674$var$revealPending = [];
const $871bb6470eebe674$var$revealObserver = new IntersectionObserver((entries)=>{
    if (!$871bb6470eebe674$var$revealReady) {
        entries.filter((e)=>e.isIntersecting).forEach((e)=>$871bb6470eebe674$var$revealPending.push(e.target));
        return;
    }
    const visible = entries.filter((e)=>e.isIntersecting);
    visible.sort((a, b)=>a.boundingClientRect.top - b.boundingClientRect.top || a.boundingClientRect.left - b.boundingClientRect.left).forEach((entry, i)=>{
        entry.target.style.setProperty("--reveal-delay", i * 110 + "ms");
        entry.target.classList.add("visible");
        $871bb6470eebe674$var$revealObserver.unobserve(entry.target);
    });
}, {
    threshold: 0.1
});
function $871bb6470eebe674$var$startReveal() {
    $871bb6470eebe674$var$revealReady = true;
    if ($871bb6470eebe674$var$revealPending.length) {
        $871bb6470eebe674$var$revealPending.sort((a, b)=>a.getBoundingClientRect().top - b.getBoundingClientRect().top).forEach((el, i)=>{
            el.style.setProperty("--reveal-delay", i * 110 + "ms");
            el.classList.add("visible");
            $871bb6470eebe674$var$revealObserver.unobserve(el);
        });
        $871bb6470eebe674$var$revealPending.length = 0;
    }
}
// ── Barre de progression latérale ────────────────────────────
(function() {
    const fill = document.getElementById("nav-fill");
    const dot = document.getElementById("nav-dot");
    if (!fill || !dot) return;
    function update() {
        const p = Math.min(1, window.scrollY / (document.body.scrollHeight - window.innerHeight || 1));
        fill.style.height = p * 100 + "%";
        dot.style.top = p * 100 + "%";
    }
    window.addEventListener("scroll", update, {
        passive: true
    });
    update();
})();
// ── Scroll reveal : labels → animateLetters / body → reveal-line ──
const $871bb6470eebe674$var$animTextObserver = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        if (!entry.isIntersecting) return;
        $871bb6470eebe674$var$animTextObserver.unobserve(entry.target);
        const el = entry.target;
        const siblings = Array.from(el.closest("section, .top, .col-text")?.querySelectorAll(".anim-text") ?? [
            el
        ]);
        const idx = Math.max(0, siblings.indexOf(el));
        // Labels et paragraphes → slide-up block (animateLetters casse le rendu sur petits textes)
        el.classList.add("reveal-block");
        setTimeout(()=>el.classList.add("visible"), idx * 140 + 60);
    });
}, {
    threshold: 0.12
});
document.querySelectorAll(".anim-text").forEach((el)=>$871bb6470eebe674$var$animTextObserver.observe(el));
// ── Statement section : apparition mot par mot au scroll ─────
(function() {
    const section = document.querySelector(".home-statement");
    if (!section) return;
    const words = Array.from(section.querySelectorAll(".sw"));
    const all = words;
    let lastRevealed = -1;
    function update() {
        const rect = section.getBoundingClientRect();
        const viewH = window.innerHeight;
        // progress : 0 quand le haut de la section touche le bas du viewport
        //            1 quand le bas de la section quitte le haut du viewport
        const start = rect.top - viewH * 1.4; // début du reveal (très tôt)
        const end = rect.top - viewH * 0.1; // fin du reveal
        const range = end - start;
        const progress = Math.max(0, Math.min(1, -start / range));
        const idx = Math.floor(progress * all.length) - 1;
        if (idx > lastRevealed) {
            for(let i = lastRevealed + 1; i <= idx; i++)all[i].classList.add("visible");
            lastRevealed = idx;
        }
    }
    window.addEventListener("scroll", update, {
        passive: true
    });
    update();
})();
// ── Déclenchement PT ─────────────────────────────────────────
const $871bb6470eebe674$var$_ptWasActive = !!sessionStorage.getItem("pt-active");
if ($871bb6470eebe674$var$_ptWasActive) {
    sessionStorage.removeItem("pt-active");
    requestAnimationFrame(()=>$871bb6470eebe674$var$PageTransition.exit($871bb6470eebe674$var$startReveal));
} else $871bb6470eebe674$var$startReveal();
// ── Animations chargement home ────────────────────────────────
const $871bb6470eebe674$var$brandTextEl = document.getElementById("brand-text");
if ($871bb6470eebe674$var$brandTextEl) setTimeout(()=>$871bb6470eebe674$var$animateLetters($871bb6470eebe674$var$brandTextEl, {
        delay: 45
    }), 100);
document.querySelectorAll(".masthead .nav a:not(.nav__logo)").forEach((el, i)=>{
    setTimeout(()=>$871bb6470eebe674$var$animateLetters(el, {
            delay: 35
        }), 200 + i * 120);
});
document.querySelectorAll(".hero-line").forEach((el, i)=>{
    setTimeout(()=>$871bb6470eebe674$var$animateLetters(el, {
            delay: 15
        }), 400 + i * 200);
});
const $871bb6470eebe674$var$taglineEl = document.querySelector(".home-hero__tagline");
if ($871bb6470eebe674$var$taglineEl) setTimeout(()=>{
    $871bb6470eebe674$var$animateLetters($871bb6470eebe674$var$taglineEl, {
        delay: 45
    });
    // centrage après que animateLetters passe en display:flex
    requestAnimationFrame(()=>requestAnimationFrame(()=>{
            $871bb6470eebe674$var$taglineEl.style.justifyContent = "center";
        }));
}, 500);
// ── Shared cross-grid builder ─────────────────────────────────
function $871bb6470eebe674$var$buildCrossGrid(container, heightFn) {
    container.querySelectorAll(".cross").forEach((el)=>el.remove());
    const vw = window.innerWidth;
    const pad = Math.max(20, Math.min(vw * 0.04, 40));
    const cols = vw <= 768 ? 4 : 6;
    const cellW = (vw - pad * 2) / cols;
    const cellH = cellW * (3 / 4);
    const rows = Math.ceil(heightFn() / cellH) + 1;
    for(let r = 0; r <= rows; r++)for(let c = 0; c <= cols; c++){
        const cross = document.createElement("div");
        cross.className = "cross";
        cross.style.position = "absolute";
        cross.style.left = pad + c * cellW + "px";
        cross.style.top = r * cellH + "px";
        container.appendChild(cross);
    }
}
// ── Hero grid crosses ─────────────────────────────────────────
const $871bb6470eebe674$var$heroGrid = document.getElementById("hero-grid");
if ($871bb6470eebe674$var$heroGrid) {
    const build = ()=>$871bb6470eebe674$var$buildCrossGrid($871bb6470eebe674$var$heroGrid, ()=>$871bb6470eebe674$var$heroGrid.offsetHeight);
    build();
    window.addEventListener("resize", build);
}
// ── Hero video grid trail (hover) ─────────────────────────────
const $871bb6470eebe674$var$heroVideoWrap = document.getElementById("hero-video-wrap");
const $871bb6470eebe674$var$heroGridHoverEl = document.getElementById("hero-grid-hover");
if ($871bb6470eebe674$var$heroVideoWrap && $871bb6470eebe674$var$heroGridHoverEl) {
    const COLS = 72;
    const ROWS = 36;
    const TRAIL_LENGTH = 18;
    const TRAIL_COLOR = "49, 49, 49";
    const cellW = 100 / COLS;
    const cellH = 100 / ROWS;
    const trailCells = [];
    for(let r = 0; r < ROWS; r++)for(let c = 0; c < COLS; c++){
        const cell = document.createElement("div");
        cell.className = "cell";
        cell.style.left = `${c * cellW}%`;
        cell.style.top = `${r * cellH}%`;
        cell.style.width = `${cellW}%`;
        cell.style.height = `${cellH}%`;
        $871bb6470eebe674$var$heroGridHoverEl.appendChild(cell);
        trailCells.push(cell);
    }
    const cellTimers = new Map();
    const trail = [];
    function getTrailCell(col, row) {
        if (col < 0 || col >= COLS || row < 0 || row >= ROWS) return null;
        return trailCells[row * COLS + col];
    }
    function lightTrailCell(col, row, intensity) {
        const c = getTrailCell(col, row);
        if (!c) return;
        if (cellTimers.has(c)) clearTimeout(cellTimers.get(c));
        c.style.background = `rgba(${TRAIL_COLOR}, ${intensity})`;
        c.style.opacity = String(intensity);
        c.style.transform = `scale(${0.55 + intensity * 0.35})`;
        c.style.transition = "background 0.05s, transform 0.08s, opacity 0.05s";
        const timer = setTimeout(()=>{
            c.style.transition = "background 0.5s ease, transform 0.5s ease, opacity 0.5s ease";
            c.style.opacity = "0";
            c.style.transform = "scale(0.6)";
            cellTimers.delete(c);
        }, 80 + (1 - intensity) * 120);
        cellTimers.set(c, timer);
    }
    $871bb6470eebe674$var$heroVideoWrap.addEventListener("mousemove", function(e) {
        const rect = this.getBoundingClientRect();
        const localX = e.clientX - rect.left;
        const localY = e.clientY - rect.top;
        if (localX < 0 || localY < 0 || localX > rect.width || localY > rect.height) return;
        const col = Math.floor(localX / rect.width * COLS);
        const row = Math.floor(localY / rect.height * ROWS);
        if (col >= COLS || row >= ROWS) return;
        trail.push({
            col: col,
            row: row
        });
        if (trail.length > TRAIL_LENGTH) trail.shift();
        trail.forEach((pt, i)=>{
            const age = i / (trail.length - 1 || 1);
            const intensity = age * age * 0.85 + 0.05;
            lightTrailCell(pt.col, pt.row, intensity);
            if (age > 0.7) [
                [
                    -1,
                    0
                ],
                [
                    1,
                    0
                ],
                [
                    0,
                    -1
                ],
                [
                    0,
                    1
                ]
            ].forEach(([dc, dr])=>{
                if (Math.random() < 0.25 * age) lightTrailCell(pt.col + dc, pt.row + dr, intensity * 0.35);
            });
        });
    });
    $871bb6470eebe674$var$heroVideoWrap.addEventListener("mouseleave", ()=>{
        trail.length = 0;
    });
}
// ── Barre de progression latérale ────────────────────────────
(function() {
    const fill = document.querySelector(".section-nav__fill");
    if (!fill) return;
    function update() {
        const scrollable = document.body.scrollHeight - window.innerHeight;
        const progress = scrollable > 0 ? Math.min(window.scrollY / scrollable, 1) : 0;
        fill.style.height = progress * 100 + "%";
    }
    window.addEventListener("scroll", update, {
        passive: true
    });
    update();
})();
// ── Masthead over-video ───────────────────────────────────────
const $871bb6470eebe674$var$masthead = document.querySelector(".masthead");
if ($871bb6470eebe674$var$masthead) {
    const heroSection = document.querySelector(".home-hero");
    function updateMastheadColor() {
        if (!heroSection) return;
        const heroBottom = heroSection.getBoundingClientRect().bottom;
        if (heroBottom > 80) $871bb6470eebe674$var$masthead.classList.add("over-video");
        else $871bb6470eebe674$var$masthead.classList.remove("over-video");
    }
    updateMastheadColor();
    window.addEventListener("scroll", updateMastheadColor, {
        passive: true
    });
}
// ── Observe images .reveal avec stagger par groupe ────────────
// Portrait about : seul dans son groupe
const $871bb6470eebe674$var$portraitEl = document.querySelector(".spread-about .reveal");
if ($871bb6470eebe674$var$portraitEl) {
    $871bb6470eebe674$var$portraitEl.style.setProperty("--reveal-delay", "0ms");
    $871bb6470eebe674$var$revealObserver.observe($871bb6470eebe674$var$portraitEl);
}
// Thumbnails travaux : stagger de 160ms entre chaque
document.querySelectorAll(".spread-work .reveal").forEach((el, i)=>{
    el.style.setProperty("--reveal-delay", i * 160 + "ms");
    $871bb6470eebe674$var$revealObserver.observe(el);
});
// ── Hero scroll hint ─────────────────────────────────────────
const $871bb6470eebe674$var$scrollHint = document.getElementById("scroll-hint");
if ($871bb6470eebe674$var$scrollHint) window.addEventListener("scroll", ()=>{
    if (window.scrollY > 40) $871bb6470eebe674$var$scrollHint.classList.add("hidden");
    else $871bb6470eebe674$var$scrollHint.classList.remove("hidden");
}, {
    passive: true
});
// ── Initial loader ────────────────────────────────────────────
function $871bb6470eebe674$var$dismissLoader(beforeExit) {
    $871bb6470eebe674$var$PageTransition.enter(()=>{
        if (beforeExit) beforeExit();
        $871bb6470eebe674$var$initialLoader.style.display = "none";
        $871bb6470eebe674$var$PageTransition.exit($871bb6470eebe674$var$startReveal);
        document.documentElement.style.overflow = "";
        document.dispatchEvent(new CustomEvent("gsap-ready"));
    });
}
const $871bb6470eebe674$var$initialLoader = document.getElementById("initial-loader");
if ($871bb6470eebe674$var$initialLoader) {
    if ($871bb6470eebe674$var$_ptWasActive) $871bb6470eebe674$var$initialLoader.style.display = "none";
    else {
        document.documentElement.style.overflow = "hidden";
        const loaderCanvas = document.getElementById("loader-canvas");
        if (loaderCanvas) {
            const lCtx = loaderCanvas.getContext("2d");
            const LCOLS = 36, LROWS = 22, LGAP = 3;
            const LPULSE_SPEED = 0.018;
            const LTRAIL = 1.2;
            const LCOLOR = [
                49,
                49,
                49
            ];
            let lW, lH, lCW, lCH, lCX, lCY, lCells = [], lPulses = [], lRaf = null;
            function lResize() {
                lW = window.innerWidth;
                lH = window.innerHeight;
                loaderCanvas.width = Math.round(lW * devicePixelRatio);
                loaderCanvas.height = Math.round(lH * devicePixelRatio);
                lCtx.setTransform(devicePixelRatio, 0, 0, devicePixelRatio, 0, 0);
                lCW = (lW - LGAP) / LCOLS;
                lCH = (lH - LGAP) / LROWS;
                lCX = lW / 2;
                lCY = lH / 2;
                lCells = [];
                for(let r = 0; r < LROWS; r++)for(let c = 0; c < LCOLS; c++){
                    const cx = c * lCW + lCW / 2 + LGAP / 2;
                    const cy = r * lCH + lCH / 2 + LGAP / 2;
                    lCells.push({
                        cx: cx,
                        cy: cy,
                        dist: Math.hypot(cx - lCX, cy - lCY)
                    });
                }
            }
            function lDraw() {
                lCtx.clearRect(0, 0, lW, lH);
                const maxDist = Math.hypot(lCX, lCY);
                const unit = Math.max(lCW, lCH);
                for (const cell of lCells){
                    let alpha = 0;
                    for (const p of lPulses){
                        const diff = p.r - cell.dist;
                        if (diff > 0 && diff < LTRAIL * unit) {
                            const t = diff / (LTRAIL * unit);
                            const a = Math.sin(t * Math.PI) * 0.82;
                            if (a > alpha) alpha = a;
                        }
                    }
                    if (alpha > 0.01) {
                        const size = (lCW - LGAP) * (0.36 + alpha * 0.28);
                        lCtx.globalAlpha = alpha;
                        lCtx.fillStyle = `rgb(${LCOLOR[0]},${LCOLOR[1]},${LCOLOR[2]})`;
                        lCtx.fillRect(cell.cx - size / 2, cell.cy - size / 2, size, size);
                    }
                }
                lCtx.globalAlpha = 1;
                const maxR = maxDist + unit * LTRAIL;
                lPulses = lPulses.filter((p)=>p.r < maxR);
                for (const p of lPulses)p.r += LPULSE_SPEED * maxDist;
                lRaf = requestAnimationFrame(lDraw);
            }
            lResize();
            lPulses.push({
                r: 0
            });
            const lInterval = setInterval(()=>lPulses.push({
                    r: 0
                }), 2200);
            lDraw();
            setTimeout(()=>{
                clearInterval(lInterval);
                $871bb6470eebe674$var$dismissLoader(()=>cancelAnimationFrame(lRaf));
            }, 3000);
        } else setTimeout(()=>$871bb6470eebe674$var$dismissLoader(), 3000);
    }
}
// ── Travaux sélectionnés → ouvre panel dans playground ────────
document.querySelectorAll(".thumb[data-project]").forEach((thumb)=>{
    thumb.style.cursor = "pointer";
    thumb.addEventListener("click", ()=>{
        sessionStorage.setItem("open-project", thumb.dataset.project);
        sessionStorage.setItem("pt-active", "1");
        $871bb6470eebe674$var$PageTransition.enter(()=>{
            window.location.href = "playground.html";
        });
    });
});
// ── Portrait parallax souris ──────────────────────────────────
(function() {
    const wrap = document.querySelector(".portrait-wrap");
    const img = document.getElementById("portrait-img");
    if (!wrap || !img) return;
    const STRENGTH = 12; // px de déplacement max
    let tX = 0, tY = 0, cX = 0, cY = 0, raf = null;
    wrap.addEventListener("mousemove", (e)=>{
        const r = wrap.getBoundingClientRect();
        const nx = (e.clientX - r.left) / r.width - 0.5; // -0.5 → 0.5
        const ny = (e.clientY - r.top) / r.height - 0.5;
        tX = nx * STRENGTH;
        tY = ny * STRENGTH;
        if (!raf) raf = requestAnimationFrame(loop);
    });
    wrap.addEventListener("mouseleave", ()=>{
        tX = 0;
        tY = 0;
        if (!raf) raf = requestAnimationFrame(loop);
    });
    function loop() {
        cX += (tX - cX) * 0.1;
        cY += (tY - cY) * 0.1;
        img.style.transform = `translate(${cX}px, ${cY}px) scale(1.06)`;
        if (Math.abs(tX - cX) > 0.05 || Math.abs(tY - cY) > 0.05) raf = requestAnimationFrame(loop);
        else {
            img.style.transform = `translate(${tX}px, ${tY}px) scale(${tX === 0 && tY === 0 ? 1 : 1.06})`;
            raf = null;
        }
    }
})();


//# sourceMappingURL=index.6cc9c160.js.map
